<ng-container
  *ngIf="!edit">
  <a
    class="text-light"
    [href]="href"
    [ngClass]="classNames"
    *ngIf="href">
    <i
      class="mdi"
      [ngClass]="'mdi-' + icon"
      *ngIf="icon">
    </i>

    <span
      [innerHTML]="value"
      *ngIf="!tag">
    </span>

    <h3
      [innerHTML]="value"
      *ngIf="(
        tag ===
        'h3'
      )">
    </h3>

    <textarea
      readonly="true"
      [innerHTML]="value"
      *ngIf="(
        tag ===
        'textarea'
      )">
    </textarea>
  </a>

  <div
    class="text-light"
    [ngClass]="classNames"
    *ngIf="!href">
    <i
      class="mdi"
      [ngClass]="'mdi-' + icon"
      *ngIf="icon">
    </i>

    <span
      [innerHTML]="value"
      *ngIf="!tag">
    </span>

    <h3
      [innerHTML]="value"
      *ngIf="(
        tag ===
        'h3'
      )">
    </h3>

    <textarea
      readonly="true"
      [innerHTML]="value"
      *ngIf="(
        tag ===
        'textarea'
      )">
    </textarea>
  </div>
</ng-container>

<div
  class="text-light"
  [ngClass]="classNames"
  *ngIf="edit">
  <i
    class="mdi"
    [ngClass]="'mdi-' + icon"
    *ngIf="icon">
  </i>

  <ng-container
    *ngIf="(
      !type ||
      (
        type ===
        'string'
      )
    )">
    <input
      #input
      [placeholder]="fallback"
      [ngModel]="value"
      (ngModelChange)="onValue($event)"
      *ngIf="(
        tag !==
        'textarea'
      )"/>

    <textarea
      [placeholder]="fallback"
      [ngModel]="value"
      (ngModelChange)="onValue($event)"
      *ngIf="(
        tag ===
        'textarea'
      )">
    </textarea>
  </ng-container>

  <input
    #input
    mask="00.00.0000"
    placeholder="DD.MM.YYYY"
    [ngModel]="value"
    (ngModelChange)="onValue($event)"
    *ngIf="(
      type ===
      'date'
    )"/>
</div>